import React from 'react'
import ProtectionUninstall from '../protection-uninstall'

const ProtectionUninstallFr = () => {
    return <ProtectionUninstall languageCode="en" />
}

export default ProtectionUninstallFr
